/* Gafas Horizon (plantilla product.wbd-horizon): el comportamiento del borrador aprobado (v11, 22-oct), con datos de Shopify.
   · #wbd-hz-config (sección «WBD · Horizon · Compra»): los modelos (sus bloques), con la variante, el precio, el stock y
     las URL de sus fotos; el pack y las rutas de la cesta.
   · Textos: los ajustes de cada sección, en elementos ocultos [data-t] (así se editan y se traducen en Shopify). Las
     lentes del simulador, en [data-lens-data] de la sección «WBD · Horizon · Lente».
   Las secciones que se quiten en el personalizador simplemente no se pintan.
   Compra: «Añadir a la cesta» = /cart/add.js (+ el código del pack con /cart/update.js) y se abre la cesta del tema;
   «Comprar ahora» = enlace de carrito /cart/ID:1,ID:1 al pago, con ?discount=CÓDIGO si es un pack.
   Dos códigos de pack (22-oct): un «Compra X y llévate Y» de Shopify solo descuenta si están TODOS los Y, así que hay
   uno para 2 pares (llévate 1) y otro para 3 (llévate 2); la página aplica el que toca. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  let C = null;
  try { const el = document.getElementById('wbd-hz-config'); C = el ? JSON.parse(el.textContent) : null; } catch (e) { console.error('wbd-horizon', e); }
  if (!C) return;
  const T = {};
  $$('[data-t]').forEach((el) => { T[el.dataset.t] = el.textContent.trim(); });
  T.add = ((document.querySelector('#wbd-add [data-lbl]') || {}).textContent || '').trim();
  const LENSES = {};
  $$('[data-lens-data]').forEach((el) => {
    const get = (k) => ((el.querySelector(`[data-k="${k}"]`) || {}).textContent || '').trim();
    LENSES[el.dataset.lensData] = { title: get('title'), note: get('note'), bands: get('bands') };
  });
  const lines = (s) => String(s || '').split('\n').map((x) => x.trim()).filter(Boolean);
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------- Modelos ---------- */
  // Sin variante (ni en la ficha ni en el producto del bloque) el modelo no se ofrece.
  const MODELS = {};
  C.order.forEach((k) => {
    const m = C.models[k];
    if (!m || !m.variant) return;
    m.key = k;
    m.checks = lines(m.checks);
    m.box = lines(m.box);
    m.imgs = m.imgs || [];
    MODELS[k] = m;
  });
  const ORDER = C.order.filter((k) => MODELS[k]);
  if (!ORDER.length) return;
  const fmt2 = new Intl.NumberFormat(C.locale, { style: 'currency', currency: C.currency });
  const fmt0 = new Intl.NumberFormat(C.locale, { style: 'currency', currency: C.currency, minimumFractionDigits: 0, maximumFractionDigits: 0 });
  const eur = (cents) => fmt2.format(cents / 100);
  const eur0 = (cents) => (cents % 100 ? fmt2 : fmt0).format(cents / 100);
  // Etiquetas de la tabla y de las especificaciones: viven en la sección Elige; si se quita, las del borrador.
  const LBL = { lens: 'Lente', blue: 'Bloqueo azul', green: 'Bloqueo verde', frame: 'Montura', seal: 'Luz lateral', use: 'Uso', drive: 'Conducción', screens: 'Trabajar con pantallas', box: 'Estuche', price: 'Precio', feature: 'Característica' };
  Object.keys(LBL).forEach((k) => { if (T['lbl-' + k]) LBL[k] = T['lbl-' + k]; });

  const q = new URLSearchParams(location.search);
  const byVariant = ORDER.find((k) => String(MODELS[k].variant) === q.get('variant'));
  const lensOn = $('[data-lens][aria-pressed="true"]');
  const state = {
    model: MODELS[q.get('modelo')] ? q.get('modelo') : (byVariant || (MODELS[C.default] ? C.default : ORDER[0])),
    addons: [], img: 0, lens: lensOn ? lensOn.dataset.lens : 'red', hour: 43, added: false, busy: false
  };
  const bind = (k, v) => $$(`[data-bind="${k}"]`).forEach((el) => { el.textContent = v; });
  const bindHtml = (k, v) => $$(`[data-bind-html="${k}"]`).forEach((el) => { el.innerHTML = v; });
  const set = (patch) => { Object.assign(state, patch); render(); };
  const available = (k) => !!(MODELS[k] && MODELS[k].available);

  /* ---------- Pack Horizon ---------- */
  // per_pair: el descuento en cada par que se añade (lo que dice el diseño). once: una sola vez por pedido (lo que hace
  // hoy el código PACKHORIZON); entonces lo lleva el primer extra elegido y el resto va a precio normal.
  const PACK = C.pack;
  function addonOff(k) {
    if (!PACK.off || !PACK.code) return 0;
    if (PACK.mode !== 'once') return PACK.off;
    const first = ORDER.find((x) => state.addons.includes(x));
    return !first || first === k ? PACK.off : 0;
  }
  const addPrice = (k) => MODELS[k].price - addonOff(k);
  const chosen = () => [state.model, ...ORDER.filter((k) => state.addons.includes(k))];
  const totalOf = () => MODELS[state.model].price + state.addons.reduce((sum, k) => sum + addPrice(k), 0);

  // Puntos de un carrusel horizontal (galería, tarjetas en móvil): uno por elemento, marca el que está a la vista.
  function wireDots(track, dots) {
    if (!track || !dots) return;
    const items = Array.from(track.children);
    dots.innerHTML = items.map((_, i) => `<button type="button" aria-label="${esc(T.goTo.replace('[n]', i + 1).replace('[total]', items.length))}"></button>`).join('');
    const btns = Array.from(dots.children);
    const mark = () => {
      const mid = track.scrollLeft + track.clientWidth / 2;
      let best = 0, dist = Infinity;
      items.forEach((it, i) => { const c = it.offsetLeft + it.offsetWidth / 2; const d = Math.abs(c - mid); if (d < dist) { dist = d; best = i; } });
      btns.forEach((b, i) => b.setAttribute('aria-current', String(i === best)));
      return best;
    };
    btns.forEach((b, i) => b.addEventListener('click', () => track.scrollTo({ left: items[i].offsetLeft - (track.clientWidth - items[i].offsetWidth) / 2, behavior: 'smooth' })));
    track.onscroll = () => { const i = mark(); if (track.id === 'wbd-track' && state.img !== i) { state.img = i; markThumbs(); } };
    mark();
  }

  function buildStatic() {
    const opts = $('#wbd-opts');
    if (opts) {
      opts.innerHTML = ORDER.map((k) => {
        const m = MODELS[k];
        const sub = available(k) ? esc(m.chip.split(' · ')[0]) : esc(T.soldout);
        return `<button class="opt" type="button" data-model="${k}" aria-pressed="false"${available(k) ? '' : ' aria-disabled="true"'}><span class="pic"><img src="${m.imgs[0] ? m.imgs[0].s : ''}" alt="" width="320" height="320"></span><span class="nm"><b>${esc(m.short)}</b><span class="pr">${eur0(m.price)}</span></span><span>${sub}</span></button>`;
      }).join('');
    }

    const cards = $('#wbd-models');
    if (cards) {
      cards.innerHTML = ORDER.map((k) => {
        const m = MODELS[k];
        return `<article class="model" data-card="${k}">
        <span class="rec">${esc(T.rec)}</span>
        <div class="pic"><img src="${m.imgs[0] ? m.imgs[0].img : ''}" alt="${esc(m.name)}" loading="lazy" width="1600" height="1067"></div>
        <div class="body">
          <span class="chip ${m.chipStyle === 'day' ? 'chip--day' : 'chip--night'}">${esc(m.chip)}</span>
          <h3><small>${esc(m.family)}</small>${esc(m.short)}</h3>
          <p class="one">${esc(m.one)}</p>
          <div class="foot"><span class="p">${eur0(m.price)}</span><a class="btn btn--ink" href="#comprar" data-pick="${k}">${esc(T.pick)} ${esc(m.short)}</a></div>
        </div>
      </article>`;
      }).join('');
      const rows = [['use', 'use'], ['blue', 'blue'], ['green', 'green'], ['screens', 'screens'], ['frame', 'frame'], ['seal', 'seal'], ['lens', 'lens'], ['box', 'box']];
      const head = $('#wbd-cmp-head');
      if (head) head.innerHTML = `<tr><th scope="col"><span class="sr">${esc(LBL.feature)}</span></th>${ORDER.map((k) => `<th scope="col">${esc(MODELS[k].short)}</th>`).join('')}</tr>`;
      const body = $('#wbd-cmp');
      if (body) {
        body.innerHTML = rows.map(([lbl, f]) => `<tr><th scope="row">${esc(LBL[lbl])}</th>${ORDER.map((k) => `<td>${esc(MODELS[k].cmp[f] || '')}</td>`).join('')}</tr>`).join('')
          + `<tr><th scope="row">${esc(LBL.price)}</th>${ORDER.map((k) => `<td><b>${eur0(MODELS[k].price)}</b></td>`).join('')}</tr>`;
      }
    }
    $$('.carousel[data-dots]').forEach((c) => wireDots(c, document.getElementById(c.dataset.dots)));
  }

  /* ---------- Hora del día (sección Elige) ---------- */
  const hourLabel = (v) => String(Math.floor(v / 2) % 24).padStart(2, '0') + ':' + (v % 2 ? '30' : '00');
  function renderDay() {
    const sky$ = $('#wbd-sky');
    if (!sky$) return;
    const v = state.hour;
    const night = v >= 40; // desde las 20:00, lente roja
    const t = (v - 16) / 32;
    let sky, orb, glow, clock;
    if (v < 34) { sky = 'linear-gradient(180deg,#7DBDFF 0%,#DCEEFF 100%)'; orb = '#FFE27A'; glow = 'rgba(255,220,110,.6)'; clock = '#000'; }
    else if (v < 40) { sky = 'linear-gradient(180deg,#5B7FC4 0%,#FFB37A 75%,#FF8A5C 100%)'; orb = '#FFB347'; glow = 'rgba(255,150,70,.6)'; clock = '#000'; }
    else if (v < 44) { sky = 'linear-gradient(180deg,#1D2E52 0%,#5B3E6E 70%,#B4584A 100%)'; orb = '#F2EFE2'; glow = 'rgba(240,235,220,.35)'; clock = '#FFFFFF'; }
    else { sky = 'linear-gradient(180deg,#111315 0%,#1F2A33 100%)'; orb = '#F2EFE2'; glow = 'rgba(240,235,220,.3)'; clock = '#FFFFFF'; }
    sky$.style.setProperty('--sky', sky);
    sky$.style.setProperty('--orb', orb);
    sky$.style.setProperty('--orb-glow', glow);
    sky$.style.setProperty('--clock', clock);
    sky$.style.setProperty('--x', (8 + t * 70) + '%');
    sky$.style.setProperty('--y', (night ? 30 : 30 + Math.abs(t - .35) * 80) + '%');
    bind('clock', hourLabel(v));
    const range = $('#wbd-hour');
    range.setAttribute('aria-valuetext', hourLabel(v));
    range.value = String(v);
    // La noche recomienda los modelos de noche; el día, los de día (estilo de la etiqueta del bloque).
    const rec = ORDER.filter((k) => (MODELS[k].chipStyle === 'day') !== night);
    $$('[data-card]').forEach((c) => c.classList.toggle('is-rec', rec.includes(c.dataset.card)));
    // En móvil las tarjetas son un carrusel: se desliza hasta la que toca (sin mover la página).
    const track = $('#wbd-models');
    if (track && rec[0] && renderDay.rec !== rec[0] && track.scrollWidth > track.clientWidth) {
      const card = track.querySelector(`[data-card="${rec[0]}"]`);
      if (card) track.scrollTo({ left: card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2, behavior: renderDay.rec ? 'smooth' : 'auto' });
    }
    renderDay.rec = rec[0];
    bind('adviceWho', night ? T.nightWho : T.dayWho);
    bind('adviceText', night ? T.nightText : T.dayText);
  }

  /* ---------- Simulador de lente (sección Lente) ---------- */
  // Zonas del espectro que tapa cada lente [desde nm, hasta nm, opacidad]: física de la lente, no texto.
  const BLOCKS = { none: [], amber: [[380, 500, .45]], red: [[380, 500, 1], [500, 560, .92]] };
  function renderLens() {
    const lens = LENSES[state.lens];
    if (!lens || !$('#lente')) return;
    $$('[data-lens]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.lens === state.lens)));
    $$('[data-layer]').forEach((l) => { l.style.opacity = l.dataset.layer === state.lens ? '1' : '0'; });
    const pct = (nm) => Math.max(0, Math.min(100, (nm - 380) / 3.2));
    $$('[data-blk]').forEach((el, i) => {
      const b = (BLOCKS[state.lens] || [])[i];
      if (!b) { el.style.opacity = '0'; return; }
      el.style.left = pct(b[0]) + '%';
      el.style.width = (pct(b[1]) - pct(b[0])) + '%';
      el.style.opacity = String(b[2]);
    });
    bind('lensTitle', lens.title);
    bind('lensNote', lens.note);
    // «Color | rango | valor | nota pequeña», separadas por «;»
    bindHtml('lensBands', lens.bands.split(';').map((x) => x.trim()).filter(Boolean).map((ln) => {
      const [k, range, v, small] = ln.split('|').map((x) => (x || '').trim());
      return `<li><span class="k"><b>${esc(k)}</b><small>${esc(range)}</small></span><span class="v"><b>${esc(v)}</b>${small ? `<small>${esc(small)}</small>` : ''}</span></li>`;
    }).join(''));
  }

  /* ---------- Compra ---------- */
  function markThumbs() {
    $$('#wbd-thumbs [data-img]').forEach((b) => b.setAttribute('aria-pressed', String(Number(b.dataset.img) === state.img)));
  }

  function renderBuy() {
    if (!$('#comprar')) return;
    const m = MODELS[state.model];
    // Extras: siempre los modelos que no están elegidos (las dos rojas pueden coincidir); sin stock, no se ofrecen.
    const others = ORDER.filter((k) => k !== state.model);
    state.addons = state.addons.filter((k) => others.includes(k) && available(k));
    const total = totalOf();
    const parts = chosen().map((k) => MODELS[k].short);
    const pack = parts.length > 1 ? T.packLabel + ' · ' + parts.join(' + ') : null;

    bind('name', m.name);
    bind('shortName', m.short);
    bind('barName', pack || T.barPrefix + ' ' + m.short);
    bind('kicker', m.kicker);
    bind('price', eur(m.price));
    bind('third', eur(Math.round(total / 3)));
    bind('total', eur(total));
    bind('summary', pack || m.short);
    bindHtml('checks', m.checks.map((c) => `<li>${esc(c)}</li>`).join(''));
    bindHtml('inbox', m.box.map((x) => `<li>${esc(x)}</li>`).join(''));
    const boxImg = $('#wbd-box-img');
    if (boxImg) {
      if (m.boxImg) { boxImg.src = m.boxImg; boxImg.alt = T.boxAlt + ' ' + m.box.join(', '); boxImg.closest('figure').hidden = false; }
      else boxImg.closest('figure').hidden = true;
    }
    const c = m.cmp;
    bindHtml('specs', [['lens', c.lens], ['blue', c.blue], ['green', c.green], ['frame', c.frame], ['seal', c.seal], ['use', c.use], ['drive', m.drive]]
      .filter(([, v]) => v).map(([k, v]) => `<dt>${esc(LBL[k])}</dt><dd>${esc(v)}</dd>`).join(''));
    $$('[data-model]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.model === state.model)));

    // Galería y extras: se rehacen solo al cambiar de modelo (la hora y la lente repintan a menudo).
    if (renderBuy.model !== state.model) {
      renderBuy.model = state.model;
      const photo = (im, i) => esc(im.alt || `${m.name}, ${T.photo} ${i + 1}`);
      $('#wbd-track').innerHTML = m.imgs.map((im, i) => `<figure class="slide${im.ai ? ' photo' : ''}"><img src="${im.ai ? im.img : im.sq}" alt="${photo(im, i)}" width="1600" height="1600"${i ? ' loading="lazy"' : ' fetchpriority="high"'}>${im.ai ? `<span class="ai-tag">${esc(T.aiTag)}</span>` : ''}</figure>`).join('');
      $('#wbd-thumbs').innerHTML = m.imgs.map((im, i) => `<button class="thumb${im.ai ? ' photo' : ''}" type="button" data-img="${i}" aria-label="${esc(T.photoOf.replace('[n]', i + 1).replace('[modelo]', m.short))}" aria-pressed="false"><img src="${im.s}" alt="" width="320" height="320" loading="lazy"></button>`).join('');
      $('#wbd-track').scrollLeft = 0;
      state.img = 0;
      wireDots($('#wbd-track'), $('#wbd-dots'));
      $('#wbd-addons').innerHTML = others.map((k) => {
        const o = MODELS[k];
        const ok = available(k);
        return `<label class="addon${ok ? '' : ' is-soldout'}"><input type="checkbox" data-addon="${k}"${ok ? '' : ' disabled'}>
          <span class="pic"><img src="${o.imgs[0] ? o.imgs[0].s : ''}" alt="" width="320" height="320" loading="lazy"></span>
          <span class="txt"><b>${esc(o.short)}</b><span>${esc(ok ? o.addon : T.soldout)}</span></span>
          <span class="pp" data-pp="${k}"></span></label>`;
      }).join('');
    }
    // Precio de cada extra: con «una vez por pedido» cambia según lo que ya esté marcado.
    others.forEach((k) => {
      const el = document.querySelector(`[data-pp="${k}"]`);
      if (!el) return;
      const p = addPrice(k), o = MODELS[k].price;
      el.innerHTML = `<span>+${eur(p)}</span>${p < o ? `<s>${eur(o)}</s>` : ''}`;
    });
    $$('[data-addon]').forEach((i) => { i.checked = state.addons.includes(i.dataset.addon); });
    markThumbs();

    const ok = available(state.model);
    const add = $('#wbd-add'), now = $('#wbd-buy-now'), barBuy = $('#wbd-bar-buy');
    [add, now, barBuy].forEach((b) => { if (!b) return; b.toggleAttribute('disabled', !ok || state.busy); b.setAttribute('aria-disabled', String(!ok || state.busy)); });
    const lbl = add && add.querySelector('[data-lbl]');
    if (lbl) lbl.textContent = !ok ? T.soldout : state.added === 'cart' ? T.added : T.add;
    const msg = $('#wbd-added');
    msg.hidden = !state.added || state.added === 'error';
    if (state.added === 'cart') msg.textContent = T.addedMsg + ' ' + parts.join(' + ') + ' · ' + eur(total);
    const err = $('#wbd-error');
    if (err) err.hidden = state.added !== 'error';
  }

  function render() { renderBuy(); renderLens(); renderDay(); }

  const items = () => chosen().filter(available).map((k) => ({ id: MODELS[k].variant, quantity: 1 }));
  const isPack = () => items().length > 1 && !!PACK.code;
  const packCode = () => (items().length >= 3 && PACK.code3 ? PACK.code3 : PACK.code);

  function buyNow() {
    if (!available(state.model)) return;
    const list = items();
    const path = C.cartUrl.replace(/\/$/, '') + '/' + list.map((i) => `${i.id}:${i.quantity}`).join(',');
    location.href = path + (isPack() ? '?discount=' + encodeURIComponent(packCode()) : '');
  }

  async function addToCart() {
    if (!available(state.model) || state.busy) return;
    set({ busy: true });
    const json = { 'Content-Type': 'application/json', Accept: 'application/json' };
    try {
      const r = await fetch(C.cartAddUrl + '.js', { method: 'POST', headers: json, body: JSON.stringify({ items: items() }) });
      if (!r.ok) throw new Error('cart/add ' + r.status);
      let cart = await (await fetch(C.cartUrl + '.js', { headers: { Accept: 'application/json' } })).json();
      if (isPack()) {
        // El código del pack se suma a los que ya tuviera la cesta (update.js con «discount» sustituye la lista entera);
        // fuera el otro código del pack, si estaba.
        const ours = [PACK.code, PACK.code3].filter(Boolean).map((x) => x.toUpperCase());
        const codes = (cart.discount_codes || []).map((d) => d.code).filter((x) => x && !ours.includes(x.toUpperCase()));
        const u = await fetch(C.cartUpdateUrl + '.js', { method: 'POST', headers: json, body: JSON.stringify({ discount: [...codes, packCode()].join(',') }) });
        if (u.ok) cart = await u.json();
      }
      set({ busy: false, added: 'cart' });
      openCart(cart);
    } catch (e) {
      console.error('wbd-horizon', e);
      set({ busy: false, added: 'error' });
    }
  }

  // Lo mismo que hace el tema al añadir: con la cesta en página (el ajuste de la tienda el 22-oct), a /cart; con la
  // cesta lateral (cart-drawer de Concept), se repinta y se abre.
  function openCart(cart) {
    const drawer = document.querySelector('cart-drawer');
    const type = window.theme && theme.settings && theme.settings.cartType;
    if (!drawer || type === 'page') { location.href = C.cartUrl; return; }
    try {
      if (theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'wbd-horizon', cart });
    } catch (e) { console.error('wbd-horizon', e); }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
  }

  function init() {
    buildStatic();

    document.addEventListener('click', (e) => {
      const pick = e.target.closest('[data-pick]');
      if (pick && MODELS[pick.dataset.pick]) set({ model: pick.dataset.pick, added: false });
      const opt = e.target.closest('#wbd-opts [data-model]');
      if (opt && MODELS[opt.dataset.model]) set({ model: opt.dataset.model, added: false });
      const th = e.target.closest('#wbd-thumbs [data-img]');
      if (th) {
        const i = Number(th.dataset.img);
        const slide = $('#wbd-track').children[i];
        if (slide) $('#wbd-track').scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        state.img = i; markThumbs();
      }
      const lens = e.target.closest('[data-lens]');
      if (lens) set({ lens: lens.dataset.lens });
    });
    const addons = $('#wbd-addons');
    if (addons) addons.addEventListener('change', (e) => {
      const k = e.target.dataset.addon;
      if (!k) return;
      const list = e.target.checked ? [...state.addons, k] : state.addons.filter((x) => x !== k);
      set({ addons: list, added: false });
    });
    const hour = $('#wbd-hour');
    if (hour) hour.addEventListener('input', (e) => { state.hour = Number(e.target.value); renderDay(); });
    const add = $('#wbd-add');
    if (add) add.addEventListener('click', addToCart);
    const now = $('#wbd-buy-now');
    if (now) now.addEventListener('click', buyNow);
    // En móvil la barra es la compra: «Comprar» va al pago; en ordenador sube al bloque de compra.
    const barBuy = $('#wbd-bar-buy');
    if (barBuy) barBuy.addEventListener('click', (e) => {
      if (matchMedia('(max-width: 900px)').matches) { e.preventDefault(); buyNow(); }
    });

    // Ordenador: la barra aparece al salir del bloque de compra. Móvil: siempre visible (CSS).
    const bar = $('#wbd-bar');
    if (bar && $('#comprar')) new IntersectionObserver((entries) => {
      entries.forEach((en) => bar.classList.toggle('show', !en.isIntersecting));
    }).observe($('#comprar'));

    render();
  }

  init();
})();
